
export default function SignupSection() {
  return (
    <section id="security" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Seguridad de Datos a Nivel Bancario
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Sus datos financieros merecen el más alto nivel de protección. Implementamos medidas de seguridad de nivel empresarial para mantener su información segura y en cumplimiento.
          </p>
        </div>

        {/* Security Features Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-16">
          <div className="bg-white border border-gray-200 rounded-xl p-6 text-center shadow-sm hover:shadow-md transition-shadow">
            <div className="w-16 h-16 bg-red-100 rounded-lg flex items-center justify-center mx-auto mb-4">
              <i className="ri-shield-keyhole-line text-2xl text-red-600"></i>
            </div>
            <h3 className="text-lg font-semibold text-gray-900 mb-2">Encriptación SSL 256-bit</h3>
            <p className="text-sm text-gray-600">Encriptación de grado militar protege toda transmisión y almacenamiento de datos</p>
          </div>

          <div className="bg-white border border-gray-200 rounded-xl p-6 text-center shadow-sm hover:shadow-md transition-shadow">
            <div className="w-16 h-16 bg-blue-100 rounded-lg flex items-center justify-center mx-auto mb-4">
              <i className="ri-key-2-line text-2xl text-blue-600"></i>
            </div>
            <h3 className="text-lg font-semibold text-gray-900 mb-2">Autenticación Multi-Factor</h3>
            <p className="text-sm text-gray-600">Múltiples capas de autenticación aseguran solo acceso autorizado</p>
          </div>

          <div className="bg-white border border-gray-200 rounded-xl p-6 text-center shadow-sm hover:shadow-md transition-shadow">
            <div className="w-16 h-16 bg-green-100 rounded-lg flex items-center justify-center mx-auto mb-4">
              <i className="ri-server-line text-2xl text-green-600"></i>
            </div>
            <h3 className="text-lg font-semibold text-gray-900 mb-2">Almacenamiento Seguro en la Nube</h3>
            <p className="text-sm text-gray-600">Infraestructura potenciada por AWS con respaldos automáticos y redundancia</p>
          </div>

          <div className="bg-white border border-gray-200 rounded-xl p-6 text-center shadow-sm hover:shadow-md transition-shadow">
            <div className="w-16 h-16 bg-purple-100 rounded-lg flex items-center justify-center mx-auto mb-4">
              <i className="ri-eye-line text-2xl text-purple-600"></i>
            </div>
            <h3 className="text-lg font-semibold text-gray-900 mb-2">Monitoreo de Seguridad 24/7</h3>
            <p className="text-sm text-gray-600">Monitoreo continuo y detección de amenazas las 24 horas</p>
          </div>
        </div>

        {/* Compliance Section */}
        <div className="bg-gradient-to-r from-teal-50 to-cyan-50 rounded-2xl p-8 mb-16">
          <div className="text-center mb-8">
            <h3 className="text-2xl font-bold text-gray-900 mb-4">Cumplimiento y Certificaciones de la Industria</h3>
            <p className="text-gray-700 max-w-2xl mx-auto">
              Mantenemos los más altos estándares de cumplimiento para proteger su negocio y asegurar adherencia regulatoria.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <div className="bg-white rounded-lg p-6 shadow-sm">
              <div className="flex items-center mb-4">
                <div className="w-12 h-12 bg-teal-500 rounded-full flex items-center justify-center mr-4">
                  <i className="ri-award-line text-white"></i>
                </div>
                <div>
                  <h4 className="font-semibold text-gray-900">SOC 2 Tipo II</h4>
                  <p className="text-sm text-gray-600">Controles de seguridad</p>
                </div>
              </div>
            </div>

            <div className="bg-white rounded-lg p-6 shadow-sm">
              <div className="flex items-center mb-4">
                <div className="w-12 h-12 bg-blue-500 rounded-full flex items-center justify-center mr-4">
                  <i className="ri-shield-check-line text-white"></i>
                </div>
                <div>
                  <h4 className="font-semibold text-gray-900">Cumplimiento GDPR</h4>
                  <p className="text-sm text-gray-600">Protección de datos europea</p>
                </div>
              </div>
            </div>

            <div className="bg-white rounded-lg p-6 shadow-sm">
              <div className="flex items-center mb-4">
                <div className="w-12 h-12 bg-cyan-500 rounded-full flex items-center justify-center mr-4">
                  <i className="ri-lock-2-line text-white"></i>
                </div>
                <div>
                  <h4 className="font-semibold text-gray-900">Listo para HIPAA</h4>
                  <p className="text-sm text-gray-600">Seguridad de datos de salud</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Security Practices */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
          <div>
            <h3 className="text-2xl font-bold text-gray-900 mb-6">Prácticas de Protección de Datos</h3>
            <div className="space-y-4">
              <div className="flex items-start">
                <div className="w-6 h-6 bg-green-100 rounded-full flex items-center justify-center mr-3 mt-1">
                  <i className="ri-check-line text-green-600 text-sm"></i>
                </div>
                <div>
                  <h4 className="font-semibold text-gray-900">Auditorías de Seguridad Regulares</h4>
                  <p className="text-gray-600 text-sm">Pruebas de penetración de terceros y evaluaciones de vulnerabilidad</p>
                </div>
              </div>

              <div className="flex items-start">
                <div className="w-6 h-6 bg-green-100 rounded-full flex items-center justify-center mr-3 mt-1">
                  <i className="ri-check-line text-green-600 text-sm"></i>
                </div>
                <div>
                  <h4 className="font-semibold text-gray-900">Arquitectura de Confianza Cero</h4>
                  <p className="text-gray-600 text-sm">Cada solicitud de acceso es verificada independientemente de la ubicación</p>
                </div>
              </div>

              <div className="flex items-start">
                <div className="w-6 h-6 bg-green-100 rounded-full flex items-center justify-center mr-3 mt-1">
                  <i className="ri-check-line text-green-600 text-sm"></i>
                </div>
                <div>
                  <h4 className="font-semibold text-gray-900">Respaldos Automatizados</h4>
                  <p className="text-gray-600 text-sm">Respaldos encriptados diarios con recuperación punto en el tiempo</p>
                </div>
              </div>

              <div className="flex items-start">
                <div className="w-6 h-6 bg-green-100 rounded-full flex items-center justify-center mr-3 mt-1">
                  <i className="ri-check-line text-green-600 text-sm"></i>
                </div>
                <div>
                  <h4 className="font-semibold text-gray-900">Control de Acceso Basado en Roles</h4>
                  <p className="text-gray-600 text-sm">Permisos granulares aseguran acceso mínimo necesario</p>
                </div>
              </div>
            </div>
          </div>

          <div>
            <h3 className="text-2xl font-bold text-gray-900 mb-6">Sus Derechos de Datos</h3>
            <div className="bg-gray-50 rounded-xl p-6">
              <div className="space-y-4">
                <div className="flex items-center">
                  <i className="ri-user-settings-line text-teal-500 mr-3"></i>
                  <span className="text-gray-700">Control completo sobre sus datos</span>
                </div>
                <div className="flex items-center">
                  <i className="ri-download-line text-teal-500 mr-3"></i>
                  <span className="text-gray-700">Exportar datos en cualquier momento en formatos estándar</span>
                </div>
                <div className="flex items-center">
                  <i className="ri-delete-bin-line text-teal-500 mr-3"></i>
                  <span className="text-gray-700">Solicitar eliminación de datos en cualquier momento</span>
                </div>
                <div className="flex items-center">
                  <i className="ri-eye-off-line text-teal-500 mr-3"></i>
                  <span className="text-gray-700">Sin compartir datos sin su consentimiento</span>
                </div>
              </div>

              <div className="mt-6 pt-6 border-t border-gray-200">
                <h4 className="font-semibold text-gray-900 mb-2">Contacto Oficial de Privacidad</h4>
                <div className="flex items-center text-sm text-gray-600">
                  <i className="ri-mail-line text-teal-500 mr-2"></i>
                  <span>privacy@ledgrkeeper.com</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Security Promise */}
        <div className="text-center mt-16">
          <div className="bg-gradient-to-r from-gray-900 to-gray-800 rounded-2xl p-8 text-white">
            <div className="max-w-3xl mx-auto">
              <h3 className="text-2xl font-bold mb-4">Nuestra Promesa de Seguridad</h3>
              <p className="text-gray-300 mb-6">
                Tratamos sus datos financieros con el mismo nivel de seguridad que los principales bancos. Nuestro compromiso con la protección de datos 
                no es solo sobre cumplimiento—es sobre ganar y mantener su confianza cada día.
              </p>
              <div className="flex flex-wrap justify-center gap-4">
                <div className="flex items-center bg-white/10 rounded-lg px-4 py-2">
                  <i className="ri-shield-star-line text-teal-300 mr-2"></i>
                  <span className="text-sm">99.9% SLA de Tiempo Activo</span>
                </div>
                <div className="flex items-center bg-white/10 rounded-lg px-4 py-2">
                  <i className="ri-time-line text-teal-300 mr-2"></i>
                  <span className="text-sm">&lt; 4hr Respuesta a Incidentes</span>
                </div>
                <div className="flex items-center bg-white/10 rounded-lg px-4 py-2">
                  <i className="ri-medal-line text-teal-300 mr-2"></i>
                  <span className="text-sm">Cero Violaciones de Datos</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}